module.exports = __webpack_public_path__ + "img/a-back.73d21dd8.png";